import { useLocation } from 'src/queries/curbside/location-details';
import { useUser } from 'src/queries/curbside/user-details';
import { useAppSelector } from 'src/utils';

export const useBaseAPIParams = () => {
  const { data: user } = useUser();
  const { data: location } = useLocation();
  const session = useAppSelector((state) => state.user.session);

  return {
    LspId: user?.LspId,
    LocId: location?.locationId,
    SessionId: session,
    UserId: user?.UserId,
  };
};
